import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { pushIf } from "./utils/pushIf";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceMilestoneRetrievalNotificationState = createStateReducer(
  initialState,
  {
    [events.retrieveMilestoneFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "retrieveMilestone",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceMilestoneRetrievalNotificationState };
